import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/springwater/movie.mp4';
const _withScopeId = n => (_pushScopeId("data-v-8ea81d46"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "desTitle",
  id: "desTitle"
};
const _hoisted_3 = {
  key: 2,
  class: "videoBg"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  src: _imports_0,
  autoplay: "autoplay",
  muted: "",
  loop: "loop"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 3,
  class: "videoGif"
};
const _hoisted_7 = {
  class: "erWeiMaCode",
  ref: "erWeiMaCode"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "erWeiMaName"
}, [/*#__PURE__*/_createTextVNode("扫一扫"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("3D文物带回家~")], -1));
const _hoisted_9 = {
  class: "btnRight"
};
const _hoisted_10 = {
  class: "swiper-container nav",
  id: "nav",
  ref: "swiperNav"
};
const _hoisted_11 = {
  class: "swiper-wrapper"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: `background-color: #fff`
}, null, -1));
const _hoisted_14 = {
  class: "btnLeft"
};
const _hoisted_15 = {
  key: 0,
  class: "navText"
};
const _hoisted_16 = {
  class: "nav_bottom"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btnTurnLeft"
}, null, -1));
const _hoisted_18 = {
  class: "swiper-container",
  ref: "swipercontainer"
};
const _hoisted_19 = {
  class: "swiper-wrapper"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["src"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "imgPao"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btnTurnRight"
}, null, -1));
const _hoisted_24 = {
  class: "nav_list",
  id: "nav_list"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "相关介绍", -1));
const _hoisted_27 = [_hoisted_25, _hoisted_26];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "相关专题", -1));
const _hoisted_30 = [_hoisted_28, _hoisted_29];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "语音讲解", -1));
const _hoisted_33 = [_hoisted_31, _hoisted_32];
const _hoisted_34 = {
  key: 7,
  class: "smallImg"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  key: 8,
  class: "content"
};
const _hoisted_37 = ["innerHTML"];
const _hoisted_38 = {
  key: 9,
  id: "voice",
  ref: "voice",
  preload: "auto"
};
const _hoisted_39 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lsDetailScript = _resolveComponent("lsDetailScript");
  const _component_lsDetail = _resolveComponent("lsDetail");
  const _component_bigImg = _resolveComponent("bigImg");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`springWaterDetail ${$data.pageType || ''}`)
  }, [!_ctx.$route.query.hideOthers ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toIndex && $options.toIndex(...args))
  })) : _createCommentVNode("", true), $data.config.logo ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "logo",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toIndex && $options.toIndex(...args))
  }, [_createElementVNode("img", {
    src: $data.config.logo
  }, null, 8, _hoisted_1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [$data.columns.length > 1 && $data.pageType ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(`column_${$data.columns.findIndex(c => {
      return c.columnName == $data.detail.columnName;
    })}`)
  }, _toDisplayString($data.detail.columnName), 3)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString($data.detail.name), 1)]), !$options.isMobile && !$data.pageType ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : (_openBlock(), _createElementBlock("div", _hoisted_6)), !$options.isMobile ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: "code",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.clickErCode && $options.clickErCode(...args))
  }, [!$data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`erWeiMa ${$data.showBigErCode ? '' : 'activeSmallEr'}`)
  }, "二维码", 2)) : _createCommentVNode("", true), $data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(`erWeiMaBig ${!$data.showBigErCode ? 'hideEr' : 'activeEr'}`)
  }, [_createElementVNode("div", _hoisted_7, null, 512), _hoisted_8], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.columns.length > 1 && !_ctx.$route.query.hideOthers ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: "topNav",
    onClick: _cache[3] || (_cache[3] = $event => $options.isMobile ? $data.showNavs = true : ''),
    style: _normalizeStyle($data.showNavs && $options.isMobile ? 'width: 85px' : ''),
    onTouchstart: _cache[4] || (_cache[4] = (...args) => $options.touchstartNav && $options.touchstartNav(...args))
  }, [_withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [[_vShow, $data.showNavs || !$options.isMobile]]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.columns, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide navItem",
      onClick: $event => $options.toColumn(item.columnName, index)
    }, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(item.columnName), 1)], 8, _hoisted_12);
  }), 256))])], 512), [[_vShow, $data.showNavs || !$options.isMobile]]), _withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [[_vShow, $data.showNavs || !$options.isMobile]]), !$data.showNavs && $options.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_15, "分类")) : _createCommentVNode("", true)], 36)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`swiper-slide ${item.code == this.detailCode && item.type == this.detail.type ? 'activeDetail' : ''}`),
      onClick: $event => $options.clickDetail(index, item.m_index)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_21), _hoisted_22], 10, _hoisted_20);
  }), 256))])], 512), _hoisted_23], 512), [[_vShow, !_ctx.$route.query.hideOthers]]), _createVNode(_component_lsDetailScript), $data.showDetail ? (_openBlock(), _createBlock(_component_lsDetail, {
    key: 6,
    class: _normalizeClass({
      'hidetransparency': $data.showModels[0] && $options.isMobile
    }),
    detailCode: $data.detailCode,
    showModels: $data.showModels,
    isMobile: $options.isMobile,
    ref: "lsDetail",
    activeIndex: $data.activeIndex,
    onHasZhuanti: $options.hasZhuanti,
    onSetParent: $options.setParent
  }, null, 8, ["class", "detailCode", "showModels", "isMobile", "activeIndex", "onHasZhuanti", "onSetParent"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
    class: _normalizeClass(`nav_item jieshao ${$data.showModels[0] ? 'active' : ''}`),
    onClick: _cache[5] || (_cache[5] = $event => $options.showModel(0))
  }, _hoisted_27, 2), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(`nav_item zhuanti ${$data.showModels[1] ? 'active' : ''}`),
    onClick: _cache[6] || (_cache[6] = $event => $options.showModel(1))
  }, _hoisted_30, 2), [[_vShow, $data.detail.zhuanti]]), $data.detail.audio ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`nav_item ${$data.showModels[2] ? 'radio' : 'radiono'}`),
    id: "radio",
    onClick: _cache[7] || (_cache[7] = $event => $options.showModel(2))
  }, _hoisted_33, 2)) : _createCommentVNode("", true)]), $data.showModels[0] && $options.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_35)])) : _createCommentVNode("", true), $data.showModels[0] ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", {
    class: "description",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_37)])) : _createCommentVNode("", true), $data.detail.audio ? (_openBlock(), _createElementBlock("audio", _hoisted_38, [_createElementVNode("source", {
    src: $data.detail.audio,
    type: "audio/mpeg"
  }, null, 8, _hoisted_39)], 512)) : _createCommentVNode("", true), $options.isMobile && $data.showBigImg ? (_openBlock(), _createBlock(_component_bigImg, {
    key: 10,
    imgs: $data.detail.images
  }, null, 8, ["imgs"])) : _createCommentVNode("", true)], 2);
}